<!--  -->
<template>
  <div class="register">
    <div class="view-wrapper">
      <div class="header color-w">
        <img class="logo" src="../assets/imgs/sr-logo.png" alt />
      </div>
      <div class="form">
        <div class="item">
          <input
            class="font-l"
            type="number"
            v-model="rpId"
            placeholder="请输入会员编号"
            ref="input0"
            @focus="inputFocus(0)"
            @blur="inputBlur"
          />
        </div>

        <div class="item query font-l" @click="bindMember">立即绑定</div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../assets/js/api.js";
import util from "../assets/js/util.js";
var that;
export default {
  data() {
    return {
      rpId: ""
    };
  },

  components: {},

  computed: {},

  mounted() {},
  created() {
    that = this;
  },

  methods: {
    bindMember() {
      if (that.rpId === "") {
        that.$toast({ message: "请输入会员编号", duration: 2000 });
        return;
      }
      that.$http
        .post(api.setMemberByRP, {
          openId: util.getss("openId"),
          rpId: that.rpId
        })
        .then(res => {
          if (res.code === util.ERR_OK) {
            util.setss("token", res.data.token);
            util.setss("memberMsg", JSON.stringify(res.data.apiMember));
            that.$router.replace({ path: "./coupon" });
          } else {
            that.$toast({ message: res.msg, duration: 2000 });
          }
        });
    },
    inputFocus(e) {
      setTimeout(() => {
        that.$refs[`input${e}`].scrollIntoViewIfNeeded();
      }, 400);
    },
    inputBlur() {
      window.scrollTo(0, 0);
    }
  }
};
</script>
<style lang='stylus' scoped>
.register {
  width: 100vw;
  height: 100vh;
  background: #000000 url('../assets/imgs/bg4.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position-x: 50%;

  .view-wrapper {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    overflow: auto;

    .header {
      padding: unit(300px) 0 unit(86px);
      font-size: unit(100px);
      text-align: center;

      .logo {
        width: unit(200rpx);
        height: unit(200rpx);
      }
    }

    /* 填写 */
    .form {
      width: unit(555px);
      margin: 0 auto;

      .item {
        width: 100%;
        height: unit(82px);
        background: rgba(245, 245, 245, 0.15);
        border-radius: unit(40px);
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: unit(40px);

        input {
          flex: 1;
          height: 100%;
          padding: 0 unit(40px) 0;
          color: #666;
          font-size: unit(36px);
          outline: none;
          border: none;
          background: #fff;
        }
      }

      .query {
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--gold);
        color: #fff;
        border: none;
        border-radius: unit(40px);
        margin-top: unit(80px);
      }
    }
  }
}
</style>